import { GPTModel } from "./gpt-models/gpt-models";

export class PromptSettings {
  creativity: Creativity;
  tone: Tone;
  webSearch: boolean;
  model: GPTModel;
  imageSize?: string;
  imageQuality?: string;
  imageStyle?: string;
  imageUseEnhancement?: boolean;

  constructor(creativity: Creativity, tone: Tone, webSearch: boolean, model?: GPTModel,
              imageSize?: string, imageQuality?: string, imageStyle?: string, imageUseEnhancement?: boolean) {
    this.creativity = creativity
    this.tone = tone
    this.webSearch = webSearch
    this.model = model ?? "gpt-4-o";
    this.imageSize = imageSize
    this.imageQuality = imageQuality
    this.imageStyle = imageStyle
    this.imageUseEnhancement = imageUseEnhancement
  }
}

export type ModelIntegration = 'text' | 'image' | 'spreadsheets';
export type ModelStatus = "available" | "beta";

export type ModelData = {
  model: GPTModel,
  name: string,
  description: string,
  integrations: ModelIntegration [],
  status: ModelStatus
};
export type ModelList = ModelData[];

export const Tones = ['PROFESSIONAL', 'FRIENDLY', 'PERSUASIVE', 'CASUAL'] as const;
export type Tone = typeof Tones[number];

export const CreativityList = [0, 1, 2, 3, 4, 5] as const;
export type Creativity = typeof CreativityList[number];
